import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import {
  LinkColor,
  LinkIconPosition,
  LinkUnderline,
  LinkWeight,
} from '@freelancer/ui/link';
import { FontColor, FontWeight, TextSize } from '@freelancer/ui/text';
import { ViewHeaderType } from '@freelancer/ui/view-header';

@Component({
  selector: 'app-navigation-logged-out-home-menu',
  template: `
    <fl-view-header
      class="ViewHeader"
      [type]="ViewHeaderType.CLOSE"
      [heading]="'mobileHeaderTitle'"
      [logo]="true"
      (close)="handleCloseButtonClick()"
    ></fl-view-header>
    <div class="MainContainer">
      <div
        class="MainContainer-nav"
        flTrackingSection="NavigationSeo"
        [class.IsMainContainerActive]="secondLayer"
      >
        <div
          class="Header"
          [flMarginBottom]="'xsmall'"
        >
          <fl-text
            i18n="Hire Freelancers Title"
            [flMarginBottom]="'small'"
            [weight]="FontWeight.BOLD"
            [color]="FontColor.LIGHT"
            [size]="TextSize.MARKETING_SMALL"
          >
            Hire Freelancers
          </fl-text>
        </div>
        <div [flMarginBottom]="'xsmall'">
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="By skill navigation item title text"
            titleLink="By skill"
            [isMobile]="true"
            [contentId]="'hireBySkill'"
            [iconName]="'ui-person-brain'"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="By location navigation item title text"
            titleLink="By location"
            [isMobile]="true"
            [contentId]="'location'"
            [iconName]="'ui-person-pin'"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="By category navigation item title text"
            titleLink="By category"
            [isMobile]="true"
            [iconName]="'ui-category'"
            [iconArrow]="false"
            [url]="'/hire'"
          ></app-navigation-logged-out-home-nav-item>
        </div>
        <div
          class="Header"
          [flMarginBottom]="'xsmall'"
        >
          <fl-text
            i18n="Find work Title"
            [flMarginBottom]="'small'"
            [weight]="FontWeight.BOLD"
            [color]="FontColor.LIGHT"
            [size]="TextSize.MARKETING_SMALL"
          >
            Find work
          </fl-text>
        </div>
        <div [flMarginBottom]="'xsmall'">
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="Find Work by skill navigation item title text"
            titleLink="By skill"
            [isMobile]="true"
            [contentId]="'findWorkByskill'"
            [iconName]="'ui-person-brain'"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="By language navigation item title text"
            titleLink="By language"
            [isMobile]="true"
            [contentId]="'language'"
            [iconName]="'ui-language'"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="Featured jobs navigation item title text"
            titleLink="Featured jobs"
            [isMobile]="true"
            [iconName]="'ui-bookmark-v2'"
            [iconArrow]="false"
            [url]="'/jobs?featured=true'"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="Find contests navigation item title text"
            titleLink="Find contests"
            [isMobile]="true"
            [iconName]="'ui-trophy'"
            [iconArrow]="false"
            [url]="'/contest'"
          ></app-navigation-logged-out-home-nav-item>
        </div>
        <div
          class="Header"
          [flMarginBottom]="'xsmall'"
        >
          <fl-text
            i18n="Solutions Title"
            [flMarginBottom]="'small'"
            [weight]="FontWeight.BOLD"
            [color]="FontColor.LIGHT"
            [size]="TextSize.MARKETING_SMALL"
          >
            Solutions
          </fl-text>
        </div>
        <div [flMarginBottom]="'xsmall'">
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="AI for business navigation item title text"
            titleLink="AI for business"
            [isMobile]="true"
            [useIconFont]="false"
            [iconSize]="IconSize.MID"
            [iconName]="'ui-ai'"
            [url]="'/ai-for-business'"
            [iconArrow]="false"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="Freelancer products navigation item title text"
            titleLink="Freelancer products"
            [isMobile]="true"
            [contentId]="'products'"
            [iconName]="'ui-bird'"
            [iconSize]="IconSize.MID"
            [useIconFont]="false"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="Freelancer services navigation item title text"
            titleLink="Freelancer services"
            [isMobile]="true"
            [contentId]="'services'"
            [iconName]="'ui-bird'"
            [iconSize]="IconSize.MID"
            [useIconFont]="false"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="Get ideas navigation item title text"
            titleLink="Get ideas"
            [isMobile]="true"
            [contentId]="'getIdeas'"
            [iconName]="'ui-lightbulb'"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
          <app-navigation-logged-out-home-nav-item
            i18n-titleLink="Resources navigation item title text"
            titleLink="Resources"
            [isMobile]="true"
            [contentId]="'resources'"
            [iconName]="'ui-book'"
            (hover)="selectTab($event)"
          ></app-navigation-logged-out-home-nav-item>
        </div>
      </div>
      <div
        class="SidePannel"
        [class.IsActive]="firstLayer || secondLayer"
        [class.IsSecondLayerActive]="secondLayer"
      >
        <div
          flTrackingSection="SkillsSection"
          id="hireBySkill"
        >
          <div
            *ngIf="selectedTab === 'hireBySkill'"
            class="SubHeader"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Hire freelancers by skill title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Hire freelancers by skill
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'hireBySkill'"
          >
            <app-navigation-logged-out-home-section-hire-freelancers-by-skills
              class="SectionStickyNav"
              (viewSecondLayer)="viewSecondLayer()"
            ></app-navigation-logged-out-home-section-hire-freelancers-by-skills>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="secondLayer && selectedTab === 'hireBySkill'"
          >
            <app-navigation-logged-out-home-section-hire-freelancers-by-skills-list />
          </div>
        </div>
        <div
          flTrackingSection="LocationSection"
          id="location"
        >
          <div
            *ngIf="selectedTab === 'location'"
            class="SubHeader"
            [flMarginBottom]="'xxxsmall'"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Hire freelancers by location title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Hire freelancers by location
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'location'"
          >
            <app-navigation-logged-out-home-section-hire-freelancers-by-location />
          </div>
        </div>
        <div
          flTrackingSection="WorkSkillsSection"
          id="findWorkByskill"
        >
          <div
            *ngIf="selectedTab === 'findWorkByskill'"
            class="SubHeader"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Find work by skill title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Find work by skill
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'findWorkByskill'"
          >
            <app-navigation-logged-out-home-section-find-work-by-skills
              (viewSecondLayer)="viewSecondLayer()"
            ></app-navigation-logged-out-home-section-find-work-by-skills>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="secondLayer && selectedTab === 'findWorkByskill'"
          >
            <app-navigation-logged-out-home-section-find-work-by-skills-list />
          </div>
        </div>
        <div
          flTrackingSection="LanguageSection"
          id="language"
        >
          <div
            *ngIf="selectedTab === 'language'"
            class="SubHeader"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Find work by language title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Find work by language
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'language'"
          >
            <app-navigation-logged-out-home-section-find-work-by-languages />
          </div>
        </div>
        <div
          flTrackingSection="ProductSection"
          id="products"
        >
          <div
            *ngIf="selectedTab === 'products'"
            class="SubHeader"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Freelancer products title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Freelancer products
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'products'"
          >
            <app-navigation-logged-out-home-section-products />
          </div>
        </div>
        <div
          flTrackingSection="ServicesSection"
          id="services"
        >
          <div
            *ngIf="selectedTab === 'services'"
            class="SubHeader"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Freelancer services title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Freelancer services
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'services'"
          >
            <app-navigation-logged-out-home-section-services />
          </div>
        </div>
        <div
          flTrackingSection="GetIdeasSection"
          id="getIdeas"
        >
          <div
            *ngIf="selectedTab === 'getIdeas'"
            class="SubHeader"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Get ideas title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Get ideas
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'getIdeas'"
          >
            <app-navigation-logged-out-home-section-get-ideas />
          </div>
        </div>
        <div
          flTrackingSection="ResourcesSection"
          id="resources"
        >
          <div
            *ngIf="selectedTab === 'resources'"
            class="SubHeader"
          >
            <fl-icon
              flTrackingLabel="GoBackToMainClick"
              [name]="'ui-arrow-left-alt'"
              [clickable]="true"
              [color]="IconColor.LIGHT"
              [size]="IconSize.SMALL"
              [flMarginRight]="'xsmall'"
              (click)="goBackToMain()"
            ></fl-icon>
            <fl-text
              i18n="Resources title"
              [color]="FontColor.LIGHT"
              [size]="TextSize.MARKETING_SMALL"
              [weight]="FontWeight.BOLD"
            >
              Resources
            </fl-text>
          </div>
          <div
            class="LayerPanel"
            [class.IsActive]="firstLayer && selectedTab === 'resources'"
          >
            <app-navigation-logged-out-home-section-resources />
          </div>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-logged-out-home-menu.component.scss'],
})
export class NavigationLoggedOutHomeMenuComponent {
  FontWeight = FontWeight;
  FontColor = FontColor;
  IconColor = IconColor;
  IconSize = IconSize;
  LinkColor = LinkColor;
  LinkIconPosition = LinkIconPosition;
  LinkWeight = LinkWeight;
  LinkUnderline = LinkUnderline;
  TextSize = TextSize;
  ViewHeaderType = ViewHeaderType;

  selectedTab?: string | undefined;
  firstLayer = false;
  secondLayer = false;

  constructor(private router: Router) {}

  selectTab(tab: string | undefined): void {
    this.selectedTab = tab;
    this.firstLayer = true;
  }

  goBackToMain(): void {
    if (this.firstLayer) {
      this.selectedTab = undefined;
      this.firstLayer = false;
    } else if (this.secondLayer) {
      this.firstLayer = true;
      this.secondLayer = false;
    }
  }

  viewSecondLayer(): void {
    this.firstLayer = false;
    this.secondLayer = true;
  }

  handleCloseButtonClick(): void {
    this.router.navigate(['']);
  }
}
